import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TTViewNavigator, TT_VIEW_NAVIGATOR, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';

@Component({
    selector: 'tt-csv-exports',
    templateUrl: './csv-exports.component.html',
    styleUrls: ['./csv-exports.component.css'],
    standalone: false,
})
export class CsvExportsComponent implements OnInit {
    @Input()
    public params?: GetCsvExportsParams;

    public itemsListCsvExports: Item[] = [];

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadCsvExports() {
        if (!!this.params) {
            this.itemsListCsvExports = await this.datatask.Post(1526, this.params);
        }
    }

    private async init() {
        this.loadCsvExports();
    }

    ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            this.init();
        }
    }
}

interface GetCsvExportsParams {
    argtype: string;
    argvalue: string;
}
